import { ComboListUrlSortField } from "@saleor/combos/urls";
import { ComboSortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(sort: ComboListUrlSortField): ComboSortField {
  switch (sort) {
    case ComboListUrlSortField.name:
      return ComboSortField.NAME;
    case ComboListUrlSortField.total_price:
      return ComboSortField.TOTAL_PRICE;
    case ComboListUrlSortField.enable:
      return ComboSortField.ENABLE;
    case ComboListUrlSortField.last_change:
      return ComboSortField.LAST_CHANGE;
    case ComboListUrlSortField.order_number:
      return ComboSortField.ORDER_NUMBER;
    default:
      return undefined;
  }
}

export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
